<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      ref="crud"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddForm('add')"
          >新 增
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          @click="downLoadParkCarQrCode"
          >场内付款码
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button type="text" size="small" icon="el-icon-edit" @click="toEdit(scope.row, 'edit')"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-download"
          v-if="scope.row.billingStatus === 1 && scope.row.passageType === 2"
          @click="downLoadTempCarQrCode(scope.row)"
          >临停付款码
        </el-button>
        <el-button
          type="text"
          v-if="scope.row.passageType === 1"
          size="small"
          icon="el-icon-download"
          @click="downLoadNoPlateCarCarQrCode(scope.row)"
          >无牌车码
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          v-if="permissionList.openBtn"
          @click="showPictureForm(scope.row)"
        >
          远程开闸
        </el-button>
        <el-button type="text" size="small" icon="el-icon-delete" @click="removePassage(scope.row)"
          >删除
        </el-button>
      </template>
    </avue-crud>
    <avue-form
      v-if="showForm"
      ref="parkPassageForm"
      v-model="form"
      :rules="rules"
      :option="option"
      @reset-change="emptyChange"
      @submit="submit"
    >
      <!-- <template slot-scope="scope" slot="menuForm">
              <el-button @click="emptyChange" icon="el-icon-delete">清空</el-button>
            </template> -->
    </avue-form>
    <div
      v-if="showPictureDialog"
      style="
        margin-left: 200px;
        background-color: mintcream;
        width: 460px;
        border: 1px solid black;
        padding-bottom: 20px;
      "
    >
      <el-form ref="remoteOperateForm" :model="remoteOperateForm" style="height: 360px">
        <div class="block">
          <el-col offset="10">{{ operateRow.passageName }}</el-col>
          <el-col span="24">
            <el-image
              :src="remoteOperateForm.grepImage"
              style="padding-left: 20px; width: 420px; height: 280px"
            >
              <div slot="error" class="image-slot">
                <div style="padding-top: 140px; padding-left: 100px">
                  {{ remoteOperateForm.imageTipMessage }}
                </div>
              </div>
            </el-image>
          </el-col>
          <el-col span="18" offset="3" style="padding-top: 15px">
            <el-button
              type="primary"
              size="small"
              v-if="permissionList.openBtn"
              @click="gateOperate(1)"
            >
              <span class="el-icon-check"></span>远程开闸
            </el-button>
            <el-button
              type="plain"
              size="small"
              v-if="permissionList.closeBtn"
              @click="gateOperate(0)"
            >
              <span class="el-icon-close"></span>远程关闸
            </el-button>
            <el-button type="info" size="small" @click="gateOperate(2)">
              <span class="el-icon-zoom-in"></span>图片查看
            </el-button>
            <el-button type="info" size="small" @click="closeOperate">
              <span class="el-icon-close"></span>收起窗口
            </el-button>
          </el-col>
        </div>
      </el-form>
    </div>
  </basic-container>
</template>

<script>
import { getToken } from '@/util/auth';
import {
  add,
  getList,
  update,
  openOrClose,
  grepImage,
  removePassage,
} from '@/api/v4ward/park/passagev2/parkpassage';
import { syncData } from '@/api/v4ward/carv2/carparkspace';
import { getPassRuleSelection } from '@/api/v4ward/park/passv2/parkpassrule';
import { mapGetters } from 'vuex';
import qrcode from 'qrcodejs2';

export default {
  props: {
    saveBtnShow: false,
    parkSpace: {},
  },
  data() {
    return {
      loading: false,
      showForm: false,
      operateType: '',
      form: {},
      syncButtonLoading: false,
      operateRow: {},
      showPictureDialog: false,
      remoteOperateForm: {
        grepping: false,
        imageTipMessage: '请点击下面图片查看抓取远程图片',
        grepImage: '',
      },
      option: {
        calcHeight: 350,
        tip: false,
        border: true,
        index: false,
        selection: false,
        columnBtn: false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menuType: 'text',
        refreshBtn: false,
        emptyBtn: false,
        align: 'center',
        menuWidth: 250,
        submitBtn: false,
        column: [
          {
            label: '所属区域',
            prop: 'regionId',
            type: 'tree',
            dicData: [],
            //row: true,
            dataType: 'string',
            dicUrl:
              '/api/v4ward/car/parkSpaceNode/nodeTreeByParentId/v2?parentId=' + this.parkSpace.id,
            //dicUrl: '/api/v4ward/car/parkSpaceNode/nodeTreeByParentId?spaceId={{key}}',
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择区域',
                trigger: 'change',
              },
            ],
          },
          {
            label: '通道名称',
            prop: 'passageName',
            maxlength: 10,
            rules: [
              {
                required: true,
                message: '请输入通道名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '通道编号',
            prop: 'passageCode',
            width: 100,
            maxlength: 32,
            rules: [
              {
                required: true,
                message: '请输入通道编号',
                trigger: 'change',
              },
              { pattern: /^[\u4E00-\u9FA5A-Za-z0-9_]+$/, message: '格式错误', trigger: 'blur' },
            ],
          },
          {
            label: '通道类型',
            prop: 'passageType',
            width: 100,
            type: 'select',
            rules: [
              {
                required: true,
                message: '请选择通道类型',
                trigger: 'blur',
              },
            ],
            dicData: [
              { label: '入口', value: 1 },
              { label: '出口', value: 2 },
              //{ label: '进出一体', value: 3 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            change: ({ value, column }) => {
              if (this.operateType === '') {
                return;
              }
              if (this.vdui.isEmpty(this.parkSpace.id) && this.vdui.isNotEmpty(value)) {
                this.$message.warning('请先选择停车场');
              }
              if (this.vdui.isNotEmpty(this.parkSpace.id) && this.vdui.isNotEmpty(value)) {
                // 加载通行规则
                this.loadPassRuleSelection(this.parkSpace.id, value);
              }
            },
          },
          {
            label: '值守情况',
            prop: 'onDutyPerson',
            width: 100,
            type: 'select',
            rules: [
              {
                required: true,
                message: '请选择是否有人值守',
                trigger: 'blur',
              },
            ],
            value: 1,
            dicData: [
              { label: '有人值守', value: 1 },
              { label: '无人值守', value: 0 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
          },
          {
            label: '是否计费',
            prop: 'billingStatus',
            type: 'select',
            rules: [
              {
                required: true,
                message: '请选择是否是计费通道',
                trigger: 'change',
              },
            ],
            value: 1,
            dicData: [
              { label: '计费通道', value: 1 },
              { label: '非计费通道', value: 0 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
          },
          {
            label: '通行规则',
            hide: true,
            type: 'select',
            dicData: [],
            //dicUrl: '/api/park/pass/rule/selections',
            props: {
              label: 'label',
              value: 'value',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择通行规则',
                trigger: 'change',
              },
            ],
            prop: 'passRuleId',
          },
          {
            label: '备注信息',
            prop: 'remark',
            span: 24,
            type: 'textarea',
            minRows: 2,
            maxlength: 100,
            showWordLimit: true,
            overHidden: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        openBtn: this.vaildData(this.permission.parkpassage_open, true),
      };
    },
  },
  created() {
    setTimeout(() => {
      document.querySelector('#pane-parkPassage > div > div > div').style =
        'padding-top:0px !important';
      document.querySelector(
        '#pane-parkPassage > div > div > div > div > div.avue-crud__pagination'
      ).style = 'padding-top:0px !important';
    });
  },
  mounted() {},
  methods: {
    formSubmit(next) {
      if (next) {
        if (this.data.length) {
          this.$emit('getQuestionResult', next);
        } else {
          this.$message({
            message: '请至少添加一条数据，再执行该操作。',
            type: 'warning',
          });
        }
      } else {
        this.$refs.parkPassageForm.submit();
        // this.onSubmit();
      }
    },
    openAddForm(operateType) {
      this.operateType = operateType;
      this.cleanForm();
      this.showForm = !this.showForm;
      this.$emit('update:saveBtnShow', this.showForm);
    },
    toEdit(row, operateType) {
      this.operateType = operateType;
      this.showForm = !this.showForm;
      this.$emit('update:saveBtnShow', this.showForm);
      this.form = Object.assign({}, row);
    },
    removePassage(row) {
      this.$confirm('确定删除该通道?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        removePassage({ id: row.id })
          .then(() => {
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
            this.onLoad();
          })
          .catch(() => {
            this.onLoad();
          });
      });
    },
    onLoad() {
      this.loading = true;
      getList(Object.assign({ current: null, size: 20 }, { parkingLotId: this.parkSpace.id })).then(
        ({ data }) => {
          this.data = data.records;
          this.loading = false;
        }
      );
    },
    loadPassRuleSelection(parkingLotId, passageType) {
      if (typeof passageType === 'undefined') {
        return;
      }
      let passRuleIdColumn = this.findObject(this.option.column, 'passRuleId');
      getPassRuleSelection({
        parkId: parkingLotId,
        passageType: passageType,
      }).then((res) => {
        if (this.operateType === 'add') {
          this.form.passRuleId = null;
        }
        passRuleIdColumn.dicData = res.data;
      });
    },
    emptyChange() {
      if (this.operateType === 'add') {
        this.cleanForm();
      } else {
        this.$message.warning('编辑时清空无效！');
      }
    },
    submit(form, done) {
      if (this.vdui.isEmpty(form.id)) {
        this.form.parkingLotId = this.parkSpace.id;
        add(this.form).then(
          () => {
            done();
            this.$message.success('操作成功!');
            this.cleanForm();
            this.onLoad();
            this.showForm = false;
            this.$emit('update:saveBtnShow', this.showForm);
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      } else {
        update(this.form).then(
          () => {
            done();
            this.$message.success('操作成功!');
            this.cleanForm();
            this.onLoad();
            this.showForm = false;
            this.$emit('update:saveBtnShow', this.showForm);
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      }
    },
    showPictureForm(row) {
      this.operateRow = row;
      this.remoteOperateForm = {
        grepping: false,
        imageTipMessage: '请点击下面图片查看抓取远程图片',
        grepImage: '',
      };
      this.showPictureDialog = true;
    },
    grepParkImage(type) {
      //图片抓取
      grepImage({ id: this.operateRow.id, type: type }).then((res) => {
        var data = res.data;
        this.remoteOperateForm.grepping = false;
        if (data.code === 200) {
          this.remoteOperateForm.grepImage = data.data;
        } else {
          this.remoteOperateForm.imageTipMessage = data.errorMessage;
        }
      });
    },
    closeOperate() {
      this.showPictureDialog = false;
    },
    gateOperate(type) {
      if (type === 2) {
        console.log('图片抓取。。');
        if (this.remoteOperateForm.grepping) {
          this.remoteOperateForm.imageTipMessage = '图片正在抓取中，请勿重复点击。。';
        } else {
          this.remoteOperateForm.imageTipMessage = '图片抓取中，请稍等。。。';
          this.remoteOperateForm.grepping = true;
          this.grepParkImage(type);
        }
      } else {
        openOrClose({ id: this.operateRow.id, type: type }).then(() => {
          this.$message.success('操作成功!');
        });
      }
    },
    //下载二维码图片
    downLoadTempCarQrCode(row) {
      window.open(`/api/v4ward/car/qrcode/tempCar/v2?Blade-Auth=${getToken()}
              &baseUrl=${location.origin}&parkingLotId=${row.parkingLotId}&passageId=${row.id}`);
    },
    // 下载场内码
    downLoadParkCarQrCode() {
      window.open(`/api/v4ward/car/qrcode/innerPay/v2?Blade-Auth=${getToken()}
              &baseUrl=${location.origin}&parkingLotId=${this.parkSpace.id}`);
    },
    // 下载无牌车入场码
    downLoadNoPlateCarCarQrCode(row) {
      window.open(`/api/v4ward/car/qrcode/noPlateCar/v2?Blade-Auth=${getToken()}
              &baseUrl=${location.origin}&parkingLotId=${row.parkingLotId}&passageId=${row.id}`);
    },
    tip(row) {
      var url = `${location.origin}/h5/carcharge/v2/#/?outCarGateId=${row.parkingLotId}_${row.id}`;
      var qrcodeName = row.passageName + '的收款码';
      this.createQrcode(url, qrcodeName);
    },
    //无牌车出入扫码
    noPlateCarQrcode(row) {
      var url = `${location.origin}/h5/carcharge/v2/#/out-yard?passageId=${row.id}`;
      if (row.passageType === 1) {
        url = `${location.origin}/h5/carcharge/v2/#/in-yard?passageId=${row.id}`;
      }
      var qrcodeName = row.passageName + '无牌车扫码';

      this.createQrcode(url, qrcodeName);
    },
    //生成二维码
    createQrcode(codeLink, imageName) {
      var div = document.createElement('div');
      const url = codeLink.replace(/\/api/, '');
      console.log('url==>', url);
      const fileName = imageName;
      var code = new qrcode(div, {
        text: url,
        width: 500,
        height: 500,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: qrcode.CorrectLevel.H,
      });
      let canvas = code._el.querySelector('canvas');
      var base64Text = canvas.toDataURL('image/png');
      var blob = this.getBlob(base64Text);
      if (navigator.msSaveBlob) {
        // IE的Blob保存方法
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement('a');
        var href = window.URL.createObjectURL(blob);
        link.href = href;
        link.download = fileName;
        document.body.appendChild(link); // firefox需要把a添加到dom才能正确执行click
        link.click();
        // 延时保证下载成功执行，否则可能下载未找到文件的问题
        setTimeout(function () {
          window.URL.revokeObjectURL(href); // 释放Url对象
          document.body.removeChild(link);
        }, 100);
      }
    },
    //下载二维码辅助方法
    getBlob(base64) {
      var mimeString = base64.split(',')[0].split(':')[1].split(';')[0]; // mime类型
      var byteString = atob(base64.split(',')[1]); //base64 解码
      var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
      var intArray = new Uint8Array(arrayBuffer); //创建视图
      for (var i = 0; i < byteString.length; i += 1) {
        intArray[i] = byteString.charCodeAt(i);
      }
      return new Blob([intArray], {
        type: mimeString,
      });
    },
    syncParkInfo(type) {
      this.syncButtonLoading = true;
      const syncParam = {
        dataRange: 2,
        dataType: type,
        parkId: this.parkSpace.id,
      };
      syncData(syncParam).then(
        () => {
          this.$message.success('操作成功！');
          this.syncButtonLoading = false;
        },
        (error) => {
          window.console.log(error);
          this.syncButtonLoading = false;
        }
      );
    },
    cleanForm() {
      for (let key in this.form) {
        this.form[key] = '';
      }
    },
  },
};
</script>
<style scoped>
#pane-parkRegion > div > div > div {
  padding-top: 0 !important;
}
</style>
